export enum BorrowerInformationLabel {
  FirstName = 'First Name',
  LastName = 'Last Name',
  HomeStreetAddress = 'Home Street Address',
  City = 'City',
  State = 'State',
  ZipCode = 'Zip Code',
  SSN = 'SSN',
  OwnershipStatus = 'Ownership Status',
  WhereHomeImprovementsOccurring = 'Address Where Home Improvements Are Occurring',
  HomeImprovementStreetAddress = 'Street Address',
  HomeImprovementCity = 'City',
  HomeImprovementState = 'State',
  HomeImprovementZipCode = 'Zip Code',
  HomeImprovementInformationIsRequired = 'This information is required',
  HomeImprovementYes = 'Yes',
  HomeImprovementNo = 'No',
  PurchaseDate = 'Purchase Date',
  PreviousStreetAddress = 'Previous Street Address',
  PreviousCity = 'Previous City',
  PreviousState = 'Previous State',
  PreviousZip = 'Previous Zip Code',
  PreviousMoveInDate = 'Previous Move In Date',
}
